import { Button, Dialog, DialogActions, DialogTitle, IconButton, Stack, useTheme } from '@mui/material'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import React from 'react'
import { NotificationDto } from '../../services/api/sharedTypes/Notification'
import CustomTextField from '../common/CustomTextField'
import CustomDatePicker from '../common/CustomDatePicker'

interface NotificationProps {
    id: number
    notification: NotificationDto
    deleteNotification: (index: number) => void
    editNotification: (index: number, editedNotification: NotificationDto) => void
}

const Notification: React.FC<NotificationProps> = ({
    id,
    notification,
    deleteNotification,
    editNotification,
}: NotificationProps) => {
    const theme = useTheme()

    const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false)
    const [date, setDate] = React.useState<Date>(notification.date)

    const handleOpenDialog = () => {
        setIsDialogOpen(true)
    }

    const handleCloseDialog = () => {
        setIsDialogOpen(false)
    }

    const confirmDeleteClient = () => {
        deleteNotification(id)
        setIsDialogOpen(false)
    }

    return (
        <Stack>
            <Stack direction='row' alignItems='center' mt={3}>
                <div>
                    <CustomDatePicker
                        onChange={(e) => {
                            if (!e) return
                            setDate(e)
                            editNotification(id, { ...notification, date: e })
                        }}
                        label='Datum'
                        value={date}
                    />
                </div>
                <div>
                    <IconButton color='error' onClick={handleOpenDialog}>
                        <DeleteOutlineRoundedIcon />
                    </IconButton>
                    <Dialog open={isDialogOpen} onClose={handleCloseDialog}>
                        <DialogTitle>Opravdu chcete upozornění {id} smazat?</DialogTitle>

                        <DialogActions>
                            <Button onClick={handleCloseDialog} variant='outlined'>
                                Ne
                            </Button>
                            <Button onClick={confirmDeleteClient} autoFocus variant='contained' color='error'>
                                Ano
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </Stack>

            <CustomTextField
                placeholder='Text'
                label='Text'
                fullWidth
                variant='outlined'
                rows={6}
                multiline
                size='small'
                value={notification.note}
                onChange={(e) => editNotification(id, { ...notification, date, note: e.target.value })}
                style={{ marginTop: theme.spacing(2) }}
            />
        </Stack>
    )
}

export default Notification
